export default {
    brand: '매일국어T',

    // 基本按钮
    buttons: {
        addAllStar: '给全体发星',
        confirm: '确认',
        cancel: '取消',
        close: '关闭',
        next: '下一步',
        previous: '上一步',
        start: '开始',
        continue: '继续',
        stop: '停止',
        exit: '退出',
        save: '保存',
        delete: '删除',
        edit: '编辑',
        submit: '提交',
        reset: '重置',
        selectAll: '全选',
        end: '结束',
        assign: '指定',
        auth: {
            login: '登录',
            logout: '退出登录',
        },
    },

    // 通用标签
    labels: {
        module: '活动',
        lesson: '活动包',
        star: '表扬星',
        waitingRoom: '等候室',
        taskPage: '前往作业列表',
        screen: '黑板屏幕',
        classroom: '教室',
        student: '学生',
        teacher: '老师',
        grade: '年级',
        school: '学校',
        name: '姓名',
        date: '日期',
        time: '时间',
        duration: '时长',
        count: '数量',
        result: '结果',
        status: '状态',
        mode: '模式',
        type: '类型',
        level: '等级',
        score: '分数',
        question: '题目',
        answer: '答案',
        online: '在线',
        offline: '离线',
        list: '列表',
    },

    // 标题栏
    headerTitle: {
        waitingRoom: '等候室',
    },

    // 通用消息
    messages: {
        confirm: '确定要{action}吗？',
        success: '{action}已完成。',
        error: '发生错误。',
        networkError: '发生网络错误。',
        loading: '加载中...',
        noData: '暂无数据。',
        selectOption: '请选择一个选项。',
    },

    // 状态
    status: {
        inProgress: '进行中',
        completed: '已完成',
        pending: '等待中',
        failed: '失败',
        locked: '已锁定',
        unlocked: '已解锁',
    },

    // 学科相关
    subject: {
        textbook: '教科书',
        korean: '语文',
        koreanActivity: '语文活动',
        math: '数学',
        science: '科学',
        socialStudies: '社会',
        english: '英语',
    },

    // 屏幕/页面相关
    screen: {
        basic: '主屏幕',
        waitingRoom: '等候室',
        activity: '活动屏幕',
        sessionResult: '课堂结果屏幕',
        moduleResult: '活动结果屏幕',
    },

    // 系统消息
    system: {
        networkError: {
            title: '网络连接不稳定。',
            message: '请稍候...',
            refresh: '刷新',
        },
        windowError: {
            closeManually: '发生错误，请手动关闭窗口。',
        },
        audio: {
            playError: '音频播放时出现问题。',
        },
    },

    // 无障碍 (alt, title 等)
    accessibility: {
        alt: {
            starDraw: '星星抽奖',
            seedLetter: '字根',
            recentSessionResult: '最近课堂结果',
            questionImage: '题目图片',
            explanationImage: '解析图片',
            photoMaterial: '图片素材',
        },
        title: {
            listen: '听声音',
            fold: '折叠写作素材',
            close: '关闭',
        },
    },

    // 单位
    units: {
        minute: '分钟',
        second: '秒',
        page: '页',
        count: '个',
        person: '名',
        person2: '人',
        times: '次',
        level: '等级',
        chapter: '课时',
        etc: '等',
        vote: '票',
        notProvided: '未提供',
        score: '分',
    },
    // teacher 组件引用的通用项
    common: {
        button: {
            cancel: '取消',
            confirm: '确认',
        },
    },
};
